<template>
    <div>
        <header-message>Enter the Last 5 Digits of the VIN</header-message>
        <form>
            <div class="container-fluid">
                <form-row :label-width="5">
                    <template #label>
                        <form-label>VIN (Last 5 Digits)</form-label>
                    </template>
                    <template #fields>
                        <numeric-keyboard v-model="vin"
                                          css-class="form-control"
                                          :maxlength="5" placeholder="Last 5 Digits of VIN"
                                          :auto-focus="true"
                                          :readonly="loading || isControlled()"
                                          @accept="accept" />
                    </template>
                </form-row>
            </div>
        </form>
        <div class="buttonrow">
            <button-button type="button" class="btn btn-secondary me-4" @click.prevent="cancelClicked" :disabled="loading">Cancel</button-button>
            <spin-button class="btn-primary" type="submit" @click.prevent="nextClicked" :spinning="loading || isControlled()" :disabled="loading || !isValid || isControlled()">Next</spin-button>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageBase from "@/shared/components/common/PageBase";
import HeaderMessage from "@/components/HeaderMessage.vue";
import { ButtonClicked } from "@/shared/enums/ButtonClicked";
import { confirmYesNo } from "@/shared/components/common/AlertDialog.vue";
import { Global } from "@/support/GlobalData";
import { SignalR } from "@/support/SignalR";
import { CalibrationEventSupport } from "@/support/CalibrationEvent";
import { CalibrationEvent } from "@/shared/enums/CalibrationEvent";
import { DeviceStatusDto } from "@/shared/models/DeviceStatusDto";

export default defineComponent({
    name: "CalibrationVin",
    components: {
        HeaderMessage,
    },
    mixins: [PageBase],
    data() {
        return {
            vin: "",
            isCompanionControlled: false,
        };
    },
    computed: {
        isValid(): boolean {
            return this.vin.match(/^[0-9]{5}$/) != null;
        },
    },
    mounted(): void {
        SignalR.onGetCurrentStatusForListeners = this.getCurrentStatusForListeners;
        SignalR.onVinSelectionByCompanion = this.setVinByCompanion;
        this.getCurrentStatusForListeners();
    },
    unmounted(): void {
        SignalR.onGetCurrentStatusForListeners = null;
        SignalR.onVinSelectionByCompanion = null;
    },
    methods: {
        isTechControlled(): boolean {
            return Global.IsTechControlled;
        },
        isControlled(): boolean {
            return this.isCompanionControlled || Global.IsTechControlled;
        },
        accept(): void {
            if (!this.isValid) return;
            this.nextClicked();
        },
        nextClicked(): void {
            CalibrationEventSupport.sendEventVin(CalibrationEvent.VinSelection, this.vin);
            this.$router.push("/Calibration/RideHeight");
        },
        setVinByCompanion(vin: string): void {
            this.vin = vin;
            this.isCompanionControlled = true;
            this.$router.push("/Calibration/RideHeight");
        },
        cancelClicked(): void {
            confirmYesNo("Are you sure you want to cancel this calibration?")
                .then((clicked: ButtonClicked): void => {
                    if (clicked === ButtonClicked.Ok) {
                        CalibrationEventSupport.sendEvent(CalibrationEvent.CalibrationCustomerCanceled);
                        Global.MainApp.clearSession();
                        this.$router.push("/");
                    }
                });
        },
        getCurrentStatusForListeners(): void {
            CalibrationEventSupport.sendEventStatus({
                Page: "CalibrationVin",
            } as DeviceStatusDto);
        },
    },
});
</script>
